import React, { Component } from 'react'
import { Map, Marker, Popup, TileLayer, withLeaflet } from 'react-leaflet'
import { ReactLeafletSearch } from 'react-leaflet-search'

import L from 'leaflet';
import * as ELG from 'esri-leaflet-geocoder';

import { connect} from "remx";
import dataStore from '../../../stores/data';
import broker from '../../../utils/broker'

// import GeoSearch from '../../../components/GeoSearch'

const ReactLeafletSearchComponent = withLeaflet(ReactLeafletSearch);

class DataMap extends Component {
    constructor(props) {
        super(props);
    
        this.options = {
            
        }
        this.state = {
            lat: -7.257472,
            lng: 112.752088,
            zoom: 13,
            data_pelanggan : {},
            position : [-7.257472, 112.752088],
            draggable : this.props.draggable,
        }
        this.updatePosition = this.updatePosition.bind(this);
        this.updateLatLong = this.updateLatLong.bind(this);
        this.handleClick = this.handleClick.bind(this);
      }

    handleClick(e){
        if (this.props.draggable)
            dataStore.setters.setLatLon(e.latlng);

        // console.log(e.latlng)
    }
    
    updatePosition(e){
        dataStore.setters.setLatLon({lat : e.target._latlng.lat, lng: e.target._latlng.lng});
    }

    componentDidMount(){
        this.setState({data_pelanggan : this.props.data_pelanggan})
        if(this.props.data_pelanggan.latitude && this.props.data_pelanggan.longitude){
            dataStore.setters.setLatLon({lat : this.props.data_pelanggan.latitude, lng: this.props.data_pelanggan.longitude});
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (this.props.data_pelanggan !== prevProps.data_pelanggan){
            this.setState({data_pelanggan : this.props.data_pelanggan})
            if(this.props.data_pelanggan.latitude && this.props.data_pelanggan.longitude){
                dataStore.setters.setLatLon({lat : this.props.data_pelanggan.latitude, lng: this.props.data_pelanggan.longitude});
            } else {
                dataStore.setters.setLatLon({lat : -7.257472, lng: 112.752088});
            }
        }
        if (this.props.draggable !== prevProps.draggable){
            if (this.props.draggable === false)
                this.updateLatLong();
                
        }
    }


    updateLatLong(){
        var body = this.props.data_pelanggan;
        body.latitude = this.props.lat_lng.lat;
        body.longitude = this.props.lat_lng.lng;

        broker.fetch.patch(`pelanggan/${this.props.pelanggan_id}`, body)
        .then(res => {
            const { data } = res;
            if (data.status === true) {
                
            } else {

            }
        }).catch(err => {
            
        });
    }

    myPopup(SearchInfo) {
        // console.log(SearchInfo);
        return(
          <Popup>
            <div>
              <p>I am a custom popUp</p>
              <p>latitude and longitude from search component: lat:{SearchInfo.latLng[0]} lng:{SearchInfo.latLng[1]}</p>
              <p>Info from search component: {SearchInfo.info}</p>
              <p>{JSON.stringify(SearchInfo.raw)}</p>
            </div>
          </Popup>
        );
      }
    
      
    render() {
        if (this.props.pelanggan_id){
            return (
                <Map center={this.state.position} zoom={this.state.zoom} style={{height:"100%"}} onClick={this.handleClick}>
                    <ReactLeafletSearchComponent
                        position="topleft"
                        provider="OpenStreetMap"
                        providerOptions={{region: 'id'}}
                        showMarker={true}
                        showPopup={true}
                        // closeResultsOnClick={true} 
                        zoom={13}
                        popUp={ this.myPopup }
                    />
                    <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker draggable={this.props.draggable} position={[this.props.lat_lng.lat, this.props.lat_lng.lng]} onDragend={this.updatePosition}>
                    <Popup>
                       {this.state.data_pelanggan.nama_pelanggan} <br /> {this.state.data_pelanggan.alamat_ip}
                    </Popup>
                    </Marker>
                </Map>
            )
        } else {
            return null;
        }
        
    }
}
function mapStateToProps(props) {
    return {
        pelanggan_id : dataStore.getters.getDataPelangganId(),
        type_view : dataStore.getters.getDataTypeView(),
        year_view : dataStore.getters.getDataYearView(),
        month_view : dataStore.getters.getDataMonthView(),
        date_view : dataStore.getters.getDataDateView(),
        data_pelanggan : dataStore.getters.getDataPelanggan(),
        lat_lng : dataStore.getters.getLatLon(),
    }
}


export default connect(mapStateToProps)(DataMap);